const BASE_URL_API = "https://tribute.dev-mm.xyz/api/";
const BASE_URL_IMAGE = "https://tribute.dev-mm.xyz/uploads/";

export { BASE_URL_API, BASE_URL_IMAGE };
